
import React from "react";
import { FormField } from "@/components/dashboard/shops/types";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { FormName } from "../formulaire-tab/FormName";
import { CTAButton } from "../formulaire-tab/CTAButton";
import { FormFieldsList } from "../formulaire-tab/FormFieldsList";
import { Trash2, Save, X, Pencil } from "lucide-react";

export interface FormContentProps {
  isEditing: boolean;
  isSaving: boolean;
  ctaButtonText: string;
  setCtaButtonText: (value: string) => void;
  formName: string;
  setFormName: (value: string) => void;
  formFields: FormField[];
  toggleFieldEnabled: (id: string) => void;
  toggleFieldRequired: (id: string) => void;
  deleteField: (id: string) => void;
  addNewField: () => void;
  updateFieldName: (id: string, name: string) => void;
  updateFieldType: (id: string, type: FormField['type']) => void;
  handleSave: () => void;
  formOrganizationId?: string;
  formShopId?: string;
  formProductIds: string[];
  setFormProductIds: (ids: string[]) => void;
  onDelete?: () => void;
  onCancel?: () => void;
}

export const FormContent: React.FC<FormContentProps> = ({
  isEditing,
  isSaving,
  ctaButtonText,
  setCtaButtonText,
  formName,
  setFormName,
  formFields,
  toggleFieldEnabled,
  toggleFieldRequired,
  deleteField,
  addNewField,
  updateFieldName,
  updateFieldType,
  handleSave,
  formOrganizationId,
  formShopId,
  formProductIds,
  setFormProductIds,
  onDelete,
  onCancel
}) => {
  return (
    <div className="space-y-8">
      <div className="flex justify-end">
        {!isEditing && (
          <Button 
            variant="outline" 
            onClick={() => onCancel && onCancel()}
          >
            <Pencil className="h-4 w-4 mr-2" />
            Modifier
          </Button>
        )}
      </div>

      <FormName 
        isEditing={isEditing}
        formName={formName}
        setFormName={setFormName}
      />
      
      <Separator />
      
      <FormFieldsList
        isEditing={isEditing}
        formFields={formFields}
        toggleFieldEnabled={toggleFieldEnabled}
        toggleFieldRequired={toggleFieldRequired}
        deleteField={deleteField}
        addNewField={addNewField}
        updateFieldName={updateFieldName}
        updateFieldType={updateFieldType}
      />
      
      <Separator />
      
      <CTAButton
        isEditing={isEditing}
        ctaButtonText={ctaButtonText}
        setCtaButtonText={setCtaButtonText}
      />
      
      <div className="flex justify-between mt-8">
        {isEditing ? (
          <>
            {onDelete && (
              <Button 
                variant="outline" 
                onClick={onDelete}
                className="text-red-500 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/20 border-red-200"
                disabled={isSaving}
              >
                <Trash2 className="h-4 w-4 mr-2" />
                Supprimer
              </Button>
            )}
            
            <div className="ml-auto flex gap-2">
              {onCancel && (
                <Button 
                  variant="outline" 
                  onClick={onCancel}
                  disabled={isSaving}
                >
                  <X className="h-4 w-4 mr-2" />
                  Annuler
                </Button>
              )}
              <Button 
                onClick={handleSave}
                disabled={isSaving}
              >
                <Save className="h-4 w-4 mr-2" />
                {isSaving ? "Enregistrement..." : "Enregistrer"}
              </Button>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};
